export default __webpack_public_path__ + "static/media/IMG_7261 copie copy.dc154745.JPG";